import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AddLeave from "@/views/management/advice/addLeave";
import byPageSelect from "@/components/byPageSelect.vue";
import TreeSelect from "@/components/TreeSelect.vue";
import answerMsgDialog from "@/views/mine/voiceMessage/answerMsgDialog.vue";
import { getLeaveMsgList } from "@/api/personalCenter/suggestAngMsg";
import { getDeptTree } from "@/api/managementCenter/otherApi";
import { getSubjectList as _getSubjectList } from "@/api/managementCenter/themeManage";
export default {
  name: "VoiceMessage",
  components: {
    byPageSelect: byPageSelect,
    TreeSelect: TreeSelect,
    answerMsgDialog: answerMsgDialog,
    AddLeave: AddLeave
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        depts: [],
        subjects: []
      },
      total: 0,
      subjectList: [],
      subjectParamSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      subjectTotal: 0,
      siftData: [{
        type: "text",
        key: "name",
        label: "主题名称",
        placeholder: "请输入主题名称",
        default: ""
      }],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
    this.getSubjectList();
    this.getDeptTreeData();
  },
  methods: {
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.departmentData = data.data;
        }
      }).catch(function (err) {});
    },
    getSubjectList: function getSubjectList() {
      var _this2 = this;

      this.$refs.pageSelect.setToading(true);

      _getSubjectList(this.subjectParamSearch).then(function (_ref2) {
        var data = _ref2.data;

        _this2.$refs.pageSelect.setToading(false);

        if (data.code == 0) {
          var list = data.data.records || [];
          _this2.subjectList = list.map(function (i) {
            return {
              value: i.id,
              name: i.name
            };
          });
          _this2.subjectTotal = data.data.total;
        }
      }).catch(function (err) {
        _this2.$refs.pageSelect.setToading(false);
      });
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.subjectParamSearch.current = value;
      this.getSubjectList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.subjectParamSearch.size = value;
      this.subjectParamSearch.current = 1;
      this.getSubjectList();
    },
    subPage: function subPage() {
      this.subjectParamSearch = _objectSpread(_objectSpread({}, this.subjectParamSearch), {}, {
        current: 1
      });
      this.getSubjectList();
    },
    setValue: function setValue(data) {
      this.paramSearch.subjects = data;
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      this.paramSearch.depts = data.map(function (item) {
        return item.id;
      });
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this3 = this;

      this.loading = true;
      getLeaveMsgList(this.paramSearch).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.list = data.data.records || [];
          _this3.total = data.data.total;
        } else {
          _this3.$message.warning(data.msg || "加载失败！");
        }
      }).catch(function () {
        _this3.$message.error("加载异常！");

        _this3.loading = false;
      });
    },
    // 查询
    searchFn: function searchFn() {
      this.paramSearch = _objectSpread(_objectSpread({}, this.paramSearch), {}, {
        current: 1
      });
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    openAddLeave: function openAddLeave(item) {
      this.$refs.addLeave.dialogShow(item.serveId, item.serveName);
    },
    openDetail: function openDetail(data) {
      this.$refs.answerMsgDialog.dialogShow(data);
    }
  }
};